import React, { useEffect, useState } from "react";
import { Inbox as InboxIcon, MessageSquare, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { usePanel } from "@/context/PanelContext";
import { timeAgo } from "@/lib/utils-tg";

export default function InboxPage() {
  const { refreshKey, open: openPanel } = usePanel();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/inbox").then((r) => setItems(r.data));
  }, [refreshKey]);

  const openItem = async (item) => {
    if (item.kind === "approval") {
      const r = await api.get("/approvals");
      const a = r.data.find((x) => x.id === item.object_id);
      if (a) openPanel("approval", a);
    }
  };

  return (
    <div className="px-6 md:px-10 pt-6 max-w-3xl mx-auto" data-testid="inbox-page">
      <div className="mb-6">
        <h1 className="font-display text-3xl font-extrabold text-slate-900">Inbox</h1>
        <p className="text-slate-500 mt-1">Mentions, thread replies, and pending requests.</p>
      </div>

      <div className="tg-card divide-y divide-slate-100">
        {items.length === 0 && (
          <div className="p-8 text-center text-slate-400 text-sm">
            <InboxIcon className="h-8 w-8 mx-auto text-slate-300 mb-2" />
            All caught up.
          </div>
        )}
        {items.map((i) => (
          <button
            key={i.id}
            onClick={() => openItem(i)}
            className="w-full text-left flex items-start gap-3 px-5 py-4 hover:bg-slate-50 transition-colors first:rounded-t-2xl last:rounded-b-2xl"
            data-testid={`inbox-item-${i.id}`}
          >
            <div className={`tg-stat-icon ${i.kind === "approval" ? "bg-orange-50" : "bg-blue-50"}`}>
              {i.kind === "approval" ? (
                <ShieldCheck className="h-4 w-4 text-orange-600" />
              ) : (
                <MessageSquare className="h-4 w-4 text-blue-600" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-slate-800 text-sm">{i.title}</div>
              <div className="text-xs text-slate-500 mt-0.5 line-clamp-2">{i.text}</div>
              <div className="text-[11px] text-slate-400 mt-1">{timeAgo(i.created_at)}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
